<script setup>
import OrganizationCard from "@/components/Organization/Card.vue";
import {inject, onMounted, ref} from "vue";
import {useOrganizations} from "@/stores/organizations";
import ProgressSpinner from "primevue/progressspinner";

const dialogRef = inject('dialogRef', null)
const $loading = ref(true);

const organizationsStore = useOrganizations()
const props = defineProps({
    item: {
        type: Object,
    }
})

const $item = ref(dialogRef.value.data.item || props.item || null)

onMounted(()=>{

    if(!$item.value.$data) {
        organizationsStore.getById($item.value.id, true).then(async (record) => {
            $item.value=record
            $loading.value = false
        })
    } else {
        $loading.value = false
    }
})

</script>
<template>
    <div v-if="$loading" class="text-center">
        <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5"></ProgressSpinner>
    </div>
    <OrganizationCard v-else-if="$item" :item="$item" />
    <div v-else>
        Organisme non spécifié.
    </div>
</template>
